$(function () {
    'use strict';

    var $searchBars = $('.search-bar');
    $searchBars.each(function initSearchBar() {
        var $searchBar = $(this),
            $header = $searchBar.closest('.menu-dropdown, aside.subnav, header').first(),
            $input = $searchBar.find('input[name="q"]'),
            $closeIcon = $searchBar.find('.f-icon.x-icon'),
            isActive = false,
            originalValue = $input.val(),
            lastInput = originalValue,
            activeClass = 'search-bar-active';

        function onFocus(e) {
            if (isActive) return;
            isActive = true;

            $header.toggleClass(activeClass, true);

            if (!originalValue) {
                $input.val(lastInput);
            }
        }

        function onBlur(e) {
            if (!isActive) return;
            isActive = false;

            $header.toggleClass(activeClass, false);
            lastInput = $input.val();

            if (!originalValue || !lastInput) {
                $input.val(originalValue).blur();
            }
        }

        function onReset(e) {
            e.stopPropagation();

            originalValue = '';
            $input.val('');
            isActive = true;
            onBlur();
        }

        if (originalValue) {
            $header.toggleClass(activeClass, true);
        }

        $closeIcon.on('touchstart mousedown', onReset);
        $input.focus(onFocus);
        $input.blur(onBlur);

        $('body').click(function (e) {
            if (
                isActive &&
                !$searchBar.has(e.target).length &&
                !$searchBar.is(e.target) &&
                !$searchBar.parent().is(e.target)
            ) {
                onBlur();
            }
        });
    });
});
